import { obj2url } from '@diezhi/momo';

let serverTime = 0;

export const getServerTime = () => {
  return serverTime;
};

export default (url, data) => {
  url = data ? `${url}?${obj2url(data)}` : url;
  return fetch(`/api/${url}`)
    .then((res) => res.json())
    .then((res) => {
      serverTime = res.timestamp;
      if (res.ret === 0) {
        return res.data;
      }
      let msg = res.msg;
      return Promise.reject(msg);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
